import { render, staticRenderFns } from "./form-edit.vue?vue&type=template&id=5d81416e&scoped=true"
import script from "./form-edit.vue?vue&type=script&lang=js"
export * from "./form-edit.vue?vue&type=script&lang=js"
import style0 from "./form-edit.vue?vue&type=style&index=0&id=5d81416e&prod&lang=css"
import style1 from "./form-edit.vue?vue&type=style&index=1&id=5d81416e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d81416e",
  null
  
)

export default component.exports